import { EXTENDED_MORTGAGE_TYPES_KEYS, MORTGAGE_PRODUCT_KEYS } from '../constants';
import { MortgageTypeIrt } from '@shared/constants';
import { AllowedUrlParams, MortgageProduct } from '@/constants';
import { RatesParams } from '@/models';
import { LocationQuery } from 'vue-router';
import { isDefined, stringToBoolean } from '@/utils';

export const firstLetterToUppercase = (date: string | Date): string | Date => (typeof date !== 'string' ? date : date.charAt(0).toUpperCase() + date.slice(1));

export function removeCookieConsent(): void {
  const consentCheck = setInterval(() => {
    const cookieConsentModal = document.getElementById('__tealiumGDPRecModal');
    if (cookieConsentModal && cookieConsentModal.classList) {
      cookieConsentModal.classList.add('d-none');
      clearInterval(consentCheck);
    }
  }, 100);
}

const isMortgageProductParam = (value: MortgageProduct | string | undefined): value is MortgageProduct => value === MortgageProduct.house || value === MortgageProduct.budget;

const isMortgageTypeParam = (value: MortgageTypeIrt | string | undefined): value is MortgageTypeIrt => Object.values(MortgageTypeIrt).includes(value as any);

const defaultRatesParams: RatesParams = {
  mortgageProduct: MortgageProduct.budget,
  mortgageType: MortgageTypeIrt.annuities,
  huisbankkorting: true,
  duurzaamheidskorting: false
};

export function getSanitizedUrlParameters(queryParams: LocationQuery): RatesParams {
  const mortgageProduct = queryParams[AllowedUrlParams.mortgageProduct] as MortgageProduct | string | undefined;
  const mortgageType = queryParams[AllowedUrlParams.mortgageType] as MortgageTypeIrt | string | undefined;
  const bankAccountDiscount: string | undefined = queryParams[AllowedUrlParams.bankAccountDiscount] as string | undefined;
  const sustainabilityDiscount: string | undefined = queryParams[AllowedUrlParams.sustainabilityDiscount] as string | undefined;

  let result = { ...defaultRatesParams };
  if (isDefined(mortgageProduct) && isMortgageProductParam(mortgageProduct)) result = { ...result, mortgageProduct };
  if (isDefined(mortgageType) && isMortgageTypeParam(mortgageType)) result = { ...result, mortgageType };
  if (isDefined(bankAccountDiscount)) result = { ...result, huisbankkorting: stringToBoolean(bankAccountDiscount) };
  if (isDefined(sustainabilityDiscount)) result = { ...result, duurzaamheidskorting: stringToBoolean(sustainabilityDiscount) };

  return result;
}

export function validateQueryParamValue(keyIndex: number, value: MortgageProduct | MortgageTypeIrt | string): boolean {
  switch (keyIndex) {
    case 0:
      return MORTGAGE_PRODUCT_KEYS.indexOf(value as MortgageProduct) > -1;
    case 1:
      return EXTENDED_MORTGAGE_TYPES_KEYS.indexOf(value as MortgageTypeIrt) > -1;
    case 2:
    case 3:
      return ['true', 'false'].indexOf(value) > -1;
    default:
      return false;
  }
}

export function getQueryParamValue(keyIndex: number, value: string): boolean | string {
  return keyIndex === 2 || keyIndex === 3 ? value === 'true' : value;
}
